<div class="user-details">
  <div class="user-header">
    <button class="btn btn-rg btn-light back-btn" (click)="goBack()">
      <ng-icon name="iconoirNavArrowLeft" size="20"></ng-icon>
      {{ dictionaryService.get('Back') }}
    </button>

    <div class="user-info">
      <div class="user-avatar">{{ userInitial }}</div>
      <h2 class="user-name">{{ userName() }}</h2>
    </div>
  </div>

  <app-main-kpis [userId]="userId()" />

  <app-tabs [defaultTab]="defaultTab()" (onChangeTab)="onTabChange($event)">
    <app-customer-visits-tab [userId]="userId()" />
    <app-monthly-report-tab [userId]="userId()" />
    <app-planner-tab [userId]="userId()" />
    <app-calls-locations-tab [userId]="userId()" />
    <app-accumulative-list-tab [userId]="userId()" [tabNameKey]="'ListDistribution'" />
    <app-products-performance-tab [userId]="userId()" />
    <app-classes-distribution-tab [userId]="userId()" />
    <app-market-samples-tab [userId]="userId()" />
    <app-product-samples-tab [userId]="userId()" />
    <app-visits-performance-tab [userId]="userId()" />
    <app-evaluations-tab [userId]="userId()" />
    <app-targeted-frequency-met-tab [userId]="userId()" [tabNameKey]="'TargetedFrequencyMet'" />
  </app-tabs>
</div>
